/**
 * Email report delivery via Vercel /api/subscribe (Resend).
 */

const getApiBase = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/$/, '');
  }
  return '';
};

export const submitEmailReport = async ({
  email,
  profile,
  typeCode,
  primaryTitle,
  secondaryTitle,
  stressFailureMode,
  weekPlan,
  shareUrl,
  printUrl,
}) => {
  const response = await fetch(`${getApiBase()}/api/subscribe`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email,
      profile,
      typeCode,
      primaryTitle,
      secondaryTitle,
      primaryPercent: profile?.percentages?.[profile?.primaryType],
      secondaryPercent: profile?.secondaryType
        ? profile?.percentages?.[profile.secondaryType]
        : null,
      confidenceLabel: profile?.confidence?.label || null,
      archetypePrimary: profile?.archetypes?.primary?.title || null,
      stressFailureMode,
      weekPlan,
      shareUrl,
      printUrl,
    }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok || !data.success) {
    throw new Error(data.message || 'Could not send your report email');
  }

  return data;
};
